"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageProvider = exports.PreferencesStorageAdapter = void 0;
var preferences_1 = require("@capacitor/preferences");
// TODO: move all these to its own meraki package
var PreferencesStorageAdapter = /** @class */ (function () {
    function PreferencesStorageAdapter() {
        var _this = this;
        this.getItem = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, preferences_1.Preferences.get({ key: key })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.value || undefined];
                }
            });
        }); };
        this.setItem = function (key, value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, preferences_1.Preferences.set({ key: key, value: value })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.removeItem = function (key) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, preferences_1.Preferences.remove({ key: key })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.exists = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var keys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, preferences_1.Preferences.keys()];
                    case 1:
                        keys = (_a.sent()).keys;
                        return [2 /*return*/, keys.includes(key)];
                }
            });
        }); };
    }
    return PreferencesStorageAdapter;
}());
exports.PreferencesStorageAdapter = PreferencesStorageAdapter;
var LocalStorageAdapter = /** @class */ (function () {
    function LocalStorageAdapter() {
        var _this = this;
        this.getItem = function (key) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, window.localStorage.getItem(key) || undefined];
            });
        }); };
        this.setItem = function (key, value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.localStorage.setItem(key, value);
                return [2 /*return*/];
            });
        }); };
        this.removeItem = function (key) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.localStorage.removeItem(key);
                return [2 /*return*/];
            });
        }); };
        this.exists = function (key) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, window.localStorage.getItem(key) !== null];
            });
        }); };
    }
    return LocalStorageAdapter;
}());
var StorageProvider = /** @class */ (function () {
    function StorageProvider() {
        var _this = this;
        this.env = 'unknown';
        this.userId = undefined;
        this.providers = {
            localStorage: new LocalStorageAdapter(),
            '@capacitor/preferences': new PreferencesStorageAdapter(),
        };
        this.getStorageImplementation = function (options) {
            return _this.providers[(options === null || options === void 0 ? void 0 : options.storageType) || '@capacitor/preferences'];
        };
        this.setEnv = function (env) {
            _this.env = env;
            return _this;
        };
        this.setUserId = function (userId) {
            _this.userId = userId;
            return _this;
        };
        this.get = function (key, options) {
            var val = localStorage.getItem(_this.getFullKey(key, options));
            if (!val) {
                return undefined;
            }
            return val;
        };
        this.getAsync = function (key, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getStorageImplementation(options).getItem(this.getFullKey(key, options))];
            });
        }); };
        this.exists = function (key, options) {
            return localStorage.getItem(_this.getFullKey(key, options)) !== null;
        };
        this.existsAsync = function (key, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getStorageImplementation(options).exists(this.getFullKey(key, options))];
            });
        }); };
        this.remove = function (key, options) {
            localStorage.removeItem(_this.getFullKey(key, options));
        };
        this.removeAsync = function (key, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getStorageImplementation(options).removeItem(this.getFullKey(key, options))];
            });
        }); };
        this.getJSON = function (key, options) {
            var json = _this.get(key, options);
            return json ? JSON.parse(json) : undefined;
        };
        this.getJSONAsync = function (key, options) { return __awaiter(_this, void 0, void 0, function () {
            var json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAsync(key, options)];
                    case 1:
                        json = _a.sent();
                        return [2 /*return*/, json ? JSON.parse(json) : undefined];
                }
            });
        }); };
        this.getFullKey = function (key, options) {
            options = options || {};
            // default to NOT env neutral and NOT user neutral since that should be most things
            if (typeof options.envNeutral !== 'boolean') {
                options.envNeutral = false;
            }
            if (typeof options.userNeutral !== 'boolean') {
                options.userNeutral = false;
            }
            var fullKey = key;
            if (!options.envNeutral && _this.env === 'unknown') {
                throw new Error("attempted to get key \"".concat(key, "\" but env is not yet known"));
            }
            if (!options.userNeutral && !_this.userId) {
                throw new Error("attempted to get key \"".concat(key, "\" but userId is not yet known"));
            }
            if (!options.userNeutral) {
                fullKey = "".concat(_this.userId, ":").concat(fullKey);
            }
            if (!options.envNeutral) {
                fullKey = "".concat(_this.env, ":").concat(fullKey);
            }
            return fullKey;
        };
        this.set = function (key, value, options) {
            localStorage.setItem(_this.getFullKey(key, options), value);
        };
        this.setAsync = function (key, value, options) { return __awaiter(_this, void 0, void 0, function () {
            var fullKey, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fullKey = this.getFullKey(key, options);
                        if (!((options === null || options === void 0 ? void 0 : options.maxBytes) && value.length >= options.maxBytes)) return [3 /*break*/, 3];
                        error = new Error("cannot save to ".concat(key, " b/c its length is ").concat(value.length, " which exceeds ").concat(options.maxBytes));
                        error.errorCode = 'too-big';
                        if (!(options === null || options === void 0 ? void 0 : options.removeOnTooBig)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getStorageImplementation(options).removeItem(fullKey)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: throw error;
                    case 3: return [2 /*return*/, this.getStorageImplementation(options).setItem(fullKey, value)];
                }
            });
        }); };
        this.setJSON = function (key, value, options) {
            localStorage.setItem(_this.getFullKey(key, options), JSON.stringify(value));
        };
        this.setJSONAsync = function (key, value, options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setAsync(key, JSON.stringify(value), options);
                return [2 /*return*/];
            });
        }); };
        /**
         * @deprecated the sync methods only work with local storage and so they should not be used
         *              b/c they make it harder to switch to preferences (or server managed state)
         *               when the time is appropriate
         */
        this.getStringProvider = function (key, options) { return ({
            exists: function () { return _this.exists(key, options); },
            get: function () { return _this.get(key, options); },
            set: function (value) { return _this.set(key, value, options); },
            remove: function () { return _this.remove(key, options); }
        }); };
        this.getAsyncStringProvider = function (key, options) { return ({
            exists: function () { return _this.existsAsync(key, options); },
            get: function () { return _this.getAsync(key, options); },
            set: function (value) { return _this.setAsync(key, value, options); },
            remove: function () { return _this.removeAsync(key, options); }
        }); };
        /**
         * @deprecated the sync methods only work with local storage and so they should not be used
         *              b/c they make it harder to switch to preferences (or server managed state)
         *               when the time is appropriate
         */
        this.getBooleanProvider = function (key, options) { return ({
            exists: function () { return _this.exists(key, options); },
            get: function () { return (_this.get(key, options) === 'true'); },
            set: function (value) { return _this.set(key, String(value), options); },
            remove: function () { return _this.remove(key, options); }
        }); };
        this.getAsyncBooleanProvider = function (key, options) { return ({
            exists: function () { return _this.existsAsync(key, options); },
            get: function () { return __awaiter(_this, void 0, void 0, function () {
                var value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getAsync(key, options)];
                        case 1:
                            value = _a.sent();
                            return [2 /*return*/, value === 'true'];
                    }
                });
            }); },
            set: function (value) { return _this.setAsync(key, String(value), options); },
            remove: function () { return _this.removeAsync(key, options); }
        }); };
        /**
         * @deprecated the sync methods only work with local storage and so they should not be used
         *              b/c they make it harder to switch to preferences (or server managed state)
         *               when the time is appropriate
         */
        this.getJSONProvider = function (key, options) { return ({
            exists: function () { return _this.exists(key, options); },
            get: function () { return _this.getJSON(key, options); },
            set: function (value) { return _this.setJSON(key, value, options); },
            remove: function () { return _this.remove(key, options); }
        }); };
        this.getAsyncJSONProvider = function (key, options) { return ({
            exists: function () { return _this.existsAsync(key, options); },
            get: function () { return _this.getJSONAsync(key, options); },
            set: function (value) { return _this.setJSONAsync(key, value, options); },
            remove: function () { return _this.removeAsync(key, options); }
        }); };
    }
    return StorageProvider;
}());
exports.StorageProvider = StorageProvider;
//# sourceMappingURL=StorageProvider.js.map